export default {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    delete: 'Delete',
    download: 'Download',
    tip: 'Tip',
    login: 'Login',
    logout: 'Logout',
    pleaseLogin: 'Please Login',
    success: 'Success',
    fail: 'Failed',
    loading: 'Loading...',
    uploadSuccess: 'Upload successful',
    uploadFail: 'Upload failed',
    operationSuccess: 'Operation successful',
    operationFail: 'Operation failed',
    networkError: 'Network connection failed, please check your network',
    serverError: 'Server error',
    requestError: 'Request failed',
    resourceNotFound: 'Requested resource not found',
    configError: 'Request configuration error',
    sessionExpired: 'Session expired, please login again',
    loginExpired: 'Login expired, please login again',
    unauthorized: 'Unauthorized, please login again',
    confirmDelete: 'Are you sure you want to delete?',
    deleteSuccess: 'Deleted successfully',
    deleteCancelled: 'Deletion cancelled',
    confirmLogout: 'Are you sure you want to logout?',
    logoutSuccess: 'Logged out successfully',
    fileDownloadStart: 'File download started',
    fileDownloadFail: 'Download failed, please try again',
    systemError: 'System error',
    pleaseWait: 'Please wait...',
  },
  nav: {
    home: 'Home',
    doctor: "I\'m a Dentist",
    patient: "I\'m a Patient",
    case: 'Case Library',
    personalInfo: 'Personal Info',
    report: 'Orthodontic Report',
    agreement: 'User Agreement',
    aboutUs: 'About Us',
  },
  breadcrumb: {
    home: 'Home',
    personalCenter: 'Personal Center',
    orthodonticReport: 'Orthodontic Report',
  },
  home: {
    title: '',
    doctorBtn: "I\'m a Dentist",
    patientBtn: "I\'m a Patient",
    caseBtn: 'Case Library',
    disclaimer1: 'This website is currently in public testing phase, reports are AI-generated for reference only',
    disclaimer2: 'Actual treatment plans should be determined by clinical physicians, our company assumes no liability',
    officialAccount: 'Official Account & Mini Program: OrthoOptimizer Technology',
    contactPhone: 'Contact: ',
    contactEmail: 'Email: ',
    address: 'Address: Room 401A1, Building 1, North District, Qianhai Shenzhen-Hong Kong Youth Innovation Hub, Menghai Avenue 5188, Nanshan Street, Qianhai Shenzhen-Hong Kong Cooperation Zone',
    pleaseLoginFirst: 'Please login first',
  },
  index: {
    title: '',
    chinese: 'Chinese',
    english: 'English',
  },
  patient: {
    newChat: 'New Chat',
    recent: 'Recent',
    threeDaysAgo: '3 days ago',
    thirtyDaysAgo: '30 days ago',
    welcome: "I\'m OrthoOptimizer, I can help you with orthodontic questions. </br> Please enter text or upload images",
    inputPlaceholder: 'Please enter your question in the dialog box. You can also upload any oral images (such as intraoral photos, facial photos, panoramic X-rays, etc.) for OrthoOptimizer to analyze',
    dragUpload: 'Drag files here to upload',
    dragUploadLimit: 'Up to 10 files supported, images accepted',
    confirmDeleteHistory: 'After deletion, this conversation cannot be recovered. Confirm deletion?',
    maxImageLimit: 'Maximum 10 images allowed',
    invalidImage: 'Please select valid image files',
    uploadFileFail: 'File upload failed',
    sendMessageFail: 'Send message',
    queryMessageFail: 'Query message',
    queryHistoryFail: 'Query history',
    queryHistoryDetailFail: 'Query history details',
    deleteHistoryFail: 'Delete history',
  },
  doctor: {
    title: 'Please submit complete patient information, </br> OrthoOptimizer will automatically generate an orthodontic treatment report for you',
    chiefComplaint: 'Chief Complaint',
    chiefComplaintPlaceholder: 'Please enter your orthodontic issue',
    age: 'Age',
    agePlaceholder: 'Please enter your age',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    step1: 'Step 1: Upload Images',
    step2: 'Step 2: Submit to Get Treatment Plan Report',
    uploadAll: 'Upload All Images',
    submitReport: 'Submit to Get Treatment Plan Report',
    uploadHint: 'Please upload the following ten complete images',
    example: 'Example',
    uploadPhoto: 'Upload Photo',
    uploadXray: 'Upload X-ray',
    photoTypes: {
      smile: 'Smile Photo',
      front: 'Frontal Photo',
      side: 'Profile Photo',
      upperTeeth: 'Upper Arch Photo',
      lowerTeeth: 'Lower Arch Photo',
      rightBite: 'Right Buccal View',
      centerBite: 'Frontal Intraoral View',
      leftBite: 'Left Buccal View',
      panorama: 'Panoramic Radiograph',
      cephalometric: 'Lateral Cephalometric Radiograph',
    },
    maxImageLimit: 'Maximum 10 images allowed',
    invalidImage: 'Please select valid image files',
    invalidFormat: 'Only JPG, JPEG, PNG formats are supported!',
    uploadSuccess: 'Upload successful!',
  },
  case: {
    tabs: {
      early: 'Early Correction',
      teen: 'Teenager Correction',
      adult: 'Adult Correction',
    },
    detailTitle: 'Case Details',
  },
  report: {
    title: 'Orthodontic Treatment Report',
    gender: 'Gender',
    age: 'Age',
    chiefComplaint: 'Chief Complaint',
    serialNum: 'Serial No.',
    generating: 'Report is being generated...',
    generateFailed: 'Report generation failed',
    downloadTypeSelect: 'Select Download Format',
    pdfFormat: 'PDF Format',
    wordFormat: 'Word Format',
    confirmDelete: 'Are you sure you want to delete this report? It cannot be recovered after deletion.',
    deleteSuccess: 'Report deleted successfully',
  },
  info: {
    tabs: {
      personalInfo: 'Personal Info',
      changePassword: 'Change Password',
      changePhone: 'Change Phone',
      changeEmail: 'Email',
      forgotPassword: 'Forgot Password',
    },
    account: 'Account',
    phone: 'Phone',
    email: 'Email',
    registerTime: 'Register Time',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    pleaseInputOldPassword: 'Please enter old password',
    pleaseInputNewPassword: 'Please enter new password',
    pleaseConfirmNewPassword: 'Please confirm new password',
    pleaseInputCurrentPassword: 'Please enter current password',
    newPasswordSameAsOld: 'New password cannot be the same as current password',
    passwordMismatch: 'The two new passwords do not match',
    changePasswordSuccess: 'Password changed successfully',
    changePasswordFail: 'Password change failed, please check if current password is correct',
    password: 'Password',
    pleaseInputPassword: 'Please enter password',
    pleaseInputPhone: 'Please enter phone number',
    pleaseInputEmail: 'Please enter email',
    pleaseInputCode: 'Please enter verification code',
    pleaseInputPhoneOrEmail: 'Please enter phone number or email',
    invalidPhone: 'Please enter a valid phone number',
    invalidEmail: 'Please enter a valid email',
    getCode: 'Get Code',
    retryAfter: 'seconds to retry',
    type: 'Type',
    phoneOrEmail: 'Phone/Email',
    newPhone: 'New Phone',
    newEmail: 'New Email',
    verifyCode: 'Verification Code',
    changePhoneSuccess: 'Phone number changed successfully',
    changePhoneFail: 'Phone change failed, please check if verification code is correct',
    changeEmailSuccess: 'Email changed successfully',
    changeEmailFail: 'Email change failed, please check if verification code is correct',
    resetPasswordSuccess: 'Password reset successful',
    resetPasswordFail: 'Password reset failed',
  },
  maintenance: {
    title: 'Website Under Maintenance',
    desc: 'Sorry, the website is undergoing system upgrades and maintenance, temporarily unavailable',
    desc2: 'We will complete the maintenance as soon as possible and restore normal service. Thank you for your understanding and patience!',
  },
  app: {
    deviceTip: 'Device Notice',
    mobileWarning: 'Since the web version is not compatible with mobile devices (phones, tablets), for a better experience, we recommend using the "OrthoOptimizer Technology" WeChat Mini Program',
    gotIt: 'Got it',
    initFailed: 'Application initialization failed',
  },
  footer: {
    securityRecord: 'GDPS Record 44030002009159',
    icpRecord: 'ICP Record 2025487643-1',
  },
  login: {
    title: 'Login',
    accountPasswordLogin: 'Account & Password',
    phoneCodeLogin: 'Phone Verification Code',
    emailCodeLogin: 'Email Verification Code',
    account: 'Account',
    password: 'Password',
    pleaseInputAccount: 'Please enter account',
    pleaseInputPassword: 'Please enter password',
    pleaseInputPhone: 'Please enter phone number',
    pleaseInputCorrectPhone: 'Please enter a valid phone number',
    pleaseInputEmail: 'Please enter email',
    pleaseInputCorrectEmail: 'Please enter a valid email',
    pleaseInputCode: 'Please enter verification code',
    getCode: 'Get Code',
    retryAfter: 's to retry',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    loginButton: 'Login',
    register: 'Register',
    noAccount: "Don't have an account?",
    registerNow: 'Register now',
    loginSuccess: 'Login successful',
    loginFail: 'Login failed, please check your credentials',
    registerTitle: 'Register Account',
    pleaseInputPhoneOrEmail: 'Please enter phone number or email',
    registerSuccess: 'Registration successful, please login',
    registerFail: 'Registration failed',
    sendCodeFail: 'Failed to send verification code',
  },
  register: {
    title: 'Register',
    account: 'Account',
    phone: 'Phone',
    verifyCode: 'Verification Code',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    pleaseInputAccount: 'Please enter account',
    pleaseInputPhone: 'Please enter phone number',
    pleaseInputCode: 'Please enter verification code',
    pleaseInputPassword: 'Please enter password',
    pleaseConfirmPassword: 'Please confirm password',
    pleaseInputPhoneFirst: 'Please enter phone number first',
    invalidPhone: 'Please enter a valid phone number',
    getCode: 'Get Code',
    retryAfter: 's to retry',
    codeSent: 'Verification code sent',
    codeSendFail: 'Failed to send verification code',
    passwordMismatch: 'Passwords do not match',
    registerButton: 'Register',
    hasAccount: 'Already have an account?',
    loginNow: 'Login now',
    registerSuccess: 'Registration successful',
    registerFail: 'Registration failed',
  },
}
